import React, { PureComponent, useState, useEffect } from 'react';
import { RepoItem } from '../autogenerated/ZoomBridge';
import { Button } from '../common';
import { Checkbox, Separator, TextBox } from '../common/form';
import t from '../i18n/I18n';
import Modal from '../modals/Modal2';
import classNames from 'classnames';
import { ThemeSetup } from '../themes/ThemeSetup';
import { FolderSelecter } from '../s3-operation/common/ZoomConfigForm';
import './SmartCopyLink.css';
import { KeyCode, SMART_COPY_PREFIX, SMART_LAST_SELECTED } from '../util/Constants';
import { getAssetPathFuids } from '../util/RepoItemUtil';
import debug from '../debug/debug';
import Storage from '../protocol/Storage';
import FlexSmartLinkExecutor from '../queries/fork/FlexSmartLinkExecutor';
import FlexSmartCopyExecutor from '../queries/fork/FlexSmartCopyExecutor';
import StringUtil from '../util/StringUtil';
import ErrorHandler from '../error/ErrorHandler';
import { showSuccessMsg } from '../store/StoreUtil';
import CheckoutController from '../controllers/CheckoutController';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import System from '../basic/System';

type Props = {
  assets: RepoItem,
  onClose: Function,
  isSmartCopy: boolean
};

export default class SmartCopyLinkDialog extends PureComponent<Props> {
  state = {
    selectedTreeAsset: { currentExpends: [0], path: '', project: '' },
    isConvertToWorkingCopy: false,
    isMakeSmartLinkWritable: false,
    revisionComment: '',
    fileName: ''
  };
  constructor(props: Props) {
    super();
    const prefix = t(SMART_COPY_PREFIX);
    const fileName = props.assets.length > 1 ? prefix : props.assets[0].getName();
    // const breadcrumbAssets: Array<RepoItem> = Store.get(BREADCRUMB_ASSETS);
    // if (breadcrumbAssets && breadcrumbAssets.length) {
    //   const currentRepo: RepoItem = _.last(breadcrumbAssets);
    //   const pwds = breadcrumbAssets.map((e) => e.getFuid());
    //   this.state.selectedTreeAsset.currentExpends.push(...pwds);
    //   this.state.selectedTreeAsset.path = currentRepo.getRemotePath();
    //   this.state.selectedTreeAsset.project = currentRepo.getProject();
    // } else {
    //   //this.state.selectedTreeAsset.currentExpends.push(...pwds);
    //   const remotePath = props.asset[0].getRemotePath().replace(`/${props.asset.getName()}`, '');
    //   this.state.selectedTreeAsset.path = remotePath;
    //   this.state.selectedTreeAsset.project = props.asset[0].getProject();
    // }
    this.state.fileName = fileName;
  }
  componentDidMount() {
    const savedPath = Storage.get(SMART_LAST_SELECTED);
    this.addEventListener();
    if (savedPath) {
      const info = JSON.parse(savedPath);
      const selectedTreeAsset = {
        currentExpends: info.currentExpends,
        path: info.path,
        project: info.project
      };
      this.setState({ selectedTreeAsset });
    } else {
      this.getParentFolder();
    }
  }

  componentWillUnmount() {
    this.removeEventListener();
  }

  addEventListener = () => {
    KeyboardShortcuts.add(new KeydownConfig('SMART_COPY_LINK_MODAL', this.onSubmit, [KeyCode.ENTER]));
  }

  removeEventListener = () => {
    KeyboardShortcuts.remove('SMART_COPY_LINK_MODAL');
  }

  getParentFolder = async () => {
    try {
      const asset: RepoItem = this.props.assets[0];
      const { pathFuids, repoItems } = await getAssetPathFuids(asset.getFuid(), true);
      const repoItem: RepoItem = repoItems.get(pathFuids[pathFuids.length - 2]);
      const selectedAssetInfo = {
        currentExpends: [0, ...pathFuids],
        path: repoItem.getRemotePath(),
        project: repoItem.getProject()
      };
      this.setState({ selectedTreeAsset: selectedAssetInfo });
    } catch (e) {
      if (debug.enabled) {
        debug('[getParentFolder()] Error get ParentFolder Data: %s %s', e);
      }
    }
  };

  onCheckBoxClick = (value) => {
    this.setState(value);
  };

  onRevisionCommentChange = (revisionComment) => {
    this.setState({ revisionComment });
  };
  onSelect = (selectedTreeAsset) => {
    //const selectedTreeAsset = { path, project, currentExpends };
    Storage.set(SMART_LAST_SELECTED, JSON.stringify(selectedTreeAsset));
    this.setState({ selectedTreeAsset: selectedTreeAsset });
  };
  onSubmit = (e: Event) => {
    e.stopPropagation();
    const { assets, isSmartCopy } = this.props;
    if (isSmartCopy) {
      const fuids = [];
      const rrns = [];
      const targetNames = [];

      if (assets.length == 1) {
        fuids.push(assets[0].getFuid());
        rrns.push('' + assets[0].getRrn());
        targetNames.push(this.state.selectedTreeAsset.path + '/' + this.state.fileName);
      } else {
        for (const asset of assets) {
          fuids.push(asset.getFuid());
          rrns.push('' + asset.getRrn());
          const name = StringUtil.appendSuffixInFileName(asset.getName(), this.state.fileName);
          targetNames.push(this.state.selectedTreeAsset.path + '/' + name);
        }
      }

      const query = new FlexSmartCopyExecutor(fuids, targetNames, rrns,this.state.revisionComment);
      query.run().then(
        (resp) => {
          if (resp._success) {
            this.issueCheckoutQuery(resp.getTargetFiles());
            showSuccessMsg(t('SMART_COPY_SUCCESS'));
          } else {
            ErrorHandler.handleError(resp._successMessage);
          }
        },
        (error) => {
          ErrorHandler.handleError(error);
        }
      ).catch(err => ErrorHandler.handleError(err)).finally(this.props.onClose);
    } else {
      // it is smart link
      const fuids = [];
      let isSuffix = undefined;
      if (assets.length == 1) {
        fuids.push(assets[0].getFuid());
        isSuffix = false;
      } else {
        isSuffix = true;
        assets.forEach(function(asset) {
          fuids.push(asset.getFuid());
        });
      }

      const query = new FlexSmartLinkExecutor(
        fuids,
        this.state.fileName,
        this.state.selectedTreeAsset.path,
        this.state.isMakeSmartLinkWritable,
        isSuffix,
        this.state.revisionComment
      );

      query.run().then(
        (resp) => {
          if (resp._success) {
            this.issueCheckoutQuery(resp.getTargetFiles());
            showSuccessMsg(t('SMART_LINK_SUCCESS'));
          } else {
            ErrorHandler.handleError(resp._successMessage);
          }
        }
      ).catch (err => ErrorHandler.handleError(err)).finally(this.props.onClose);
    }
    this.props.onClose(true);
  };

  issueCheckoutQuery = (infiles) => {
    if (this.state.isConvertToWorkingCopy) {
      const checkoutController = new CheckoutController(infiles, false, false, null, 'checkout', true);
      checkoutController.run();
    }
  };

  onFileNameChange = (e) => {
    this.setState({ fileName: e.target.value });
  };
  getFooter = () => {
    const { isSmartCopy } = this.props;
    return (
      <DialogFooter
        onCheckBoxClick={this.onCheckBoxClick}
        isSmartCopy={isSmartCopy}
        isConvertToWorkingCopy={this.state.isConvertToWorkingCopy}
        isMakeSmartLinkWritable={this.state.isMakeSmartLinkWritable}
        buttons={[
          {
            label: t('CANCEL'),
            type: 'CANCEL',
            onClick: this.props.onClose,
            // className: 'model-viewLeftButton'
          },
          {
            label: isSmartCopy ? t('SMART_COPY') : t('SMART_LINK'),
            type: 'PRIMARY',
            onClick: this.onSubmit
          }
        ]}
      />
    );
  };
  render() {
    const { currentExpends, path, project } = this.state.selectedTreeAsset;
    const { assets, onClose, isSmartCopy } = this.props;
    const { revisionComment, fileName } = this.state;
    const props = {
      name: 'SmartCopyLink',
      onClose,
      title: isSmartCopy ? t('SMART_COPY') : t('SMART_LINK'),
      footer: this.getFooter()
    };
    return (
      <Modal {...props} closeOnEsc={true} closeOnOutsideClick={false}>
        <div className="row">
          <div className="col-12 mb-4">
            <label>{assets.length === 1 ? t('ENTER_FILE_NAME_PROMPT') : t('FILES_NAME')}</label>
            <div className="d-inline-flex input-container" style={{ width: '100%' }}>
              <span>
                <img src={ThemeSetup.getImageURL('refactor/icons_file.svg')} style={{'width': '18px', 'height': '18px'}}/>
              </span>
              <TextBox value={fileName} onChange={this.onFileNameChange} clearable={false} onKeyDown={(e: KeyboardEvent) => { e.which === KeyCode.ENTER ? this.onSubmit(e) : null;}} />
            </div>
          </div>
          <div className="col-12 mb-4">
            <label>{t('DESTINATION_FOLDER')}</label>
            <FileSelectedTextField
              path={path}
              project={project}
              currentExpends={currentExpends}
              isActive={false}
              setActive={() => {}}
              onSelect={this.onSelect}
              index={0}
              itemIndex={1}
            />
          </div>
          <div className="col-12 mt-2">
            <Separator />
            <RevisonComment onRevisionCommentChange={this.onRevisionCommentChange} revisionComment={revisionComment} />
            <Separator />
          </div>
        </div>
      </Modal>
    );
  }
}

const DialogFooter = ({ buttons, isConvertToWorkingCopy, onCheckBoxClick, isMakeSmartLinkWritable, isSmartCopy }) => {
  return (
    <footer className={classNames('position-reletive', { center: buttons.length === 1 })}>
      <div className="position-absolute d-flex checkin-box" style={{ left: '40px' }}>
        {System.isDesktop() ? <Checkbox
          checked={isConvertToWorkingCopy}
          onChange={() => onCheckBoxClick({ isConvertToWorkingCopy: !isConvertToWorkingCopy })}
          label={t('CONVERT_TO_WORKING_COPY')}
        /> : null}
        <span className="ml-4" />
        {!isSmartCopy ? (
          <Checkbox
            checked={isMakeSmartLinkWritable}
            onChange={() => onCheckBoxClick({ isMakeSmartLinkWritable: !isMakeSmartLinkWritable })}
            label={t('MAKE_SMART_LINK_WRITABLE')}
          />
        ) : null}
      </div>
      {buttons.map((b, i) => (
        <Button
          key={i}
          text={b.label}
          type={b.type}
          className={b.className}
          disabled={b.disabled}
          onClick={b.onClick}
          style={b.style ? b.style : {}}
        />
      ))}
    </footer>
  );
};

export const FileSelectedTextField = ({ path, project, currentExpends, onSelect, isFatchNeeded }) => {
  const [isShowSelector, setIsShowSelector] = useState(false);
  const [selected, setSelected] = useState({ path, project, currentExpends });

  useEffect(() => {
    setSelected({ path, project, currentExpends });
  }, [path, project, currentExpends]);

  const onFocus = function() {
    setIsShowSelector(true);
  };

  const onSelectClick = () => {
    onSelect(selected);
    onCancel();
  };

  const setSelectedFunc = function(path, asset, pwd) {
    const tempPath = { path, project: asset.getProject(), currentExpends: pwd };
    setSelected(tempPath);
  };

  const onCancel = () => {
    setIsShowSelector(false);
  };

  const getStyle = () => {
    const el = document.getElementById('SmartCopyLinkInput');
    if (el) {
      const clientRect = el.getBoundingClientRect();
      let top = clientRect.top + 39;
      return {
        left: clientRect.left + document.body.scrollLeft - 30,
        top: top - 10,
        width: clientRect.width,
        zIndex: 999,
        maxHeight: `calc(100% - ${top}px)`
      };
    }
    return {};
  };

  return (
    <div className="position-relative mb-1">
      <div className="d-inline-flex" style={{ width: '100%' }}>
        <div className="d-inline-flex input-container" style={{ width: '100%' }}>
          <span>
            <img src={ThemeSetup.getImageURL('folder.svg')} style={{width: '20px', marginBottom: '2px'}}/>
          </span>
          <TextBox
            placeholder={t('FILE_PATH')}
            onFocus={onFocus}
            value={selected.path}
            clearable={false}
            onChange={() => {}}
            focusOnClear={false}
            disabled={isShowSelector}
            id={'SmartCopyLinkInput'}
          />
        </div>
      </div>
      {isShowSelector ? (
        <FolderSelecter
          onCloseClick={onCancel}
          onselectedPath={setSelectedFunc}
          onClickSelect={onSelectClick}
          currentExpends={selected.currentExpends}
          isIndependentTreeIns={true}
          style={getStyle()}
        />
      ) : null}
    </div>
  );
};

const RevisonComment = ({ revisionComment, onRevisionCommentChange }) => {
  const [comment, setComment] = useState(revisionComment);
  const onBlur = () => {
    onRevisionCommentChange(comment);
    // if (!comment) {
    //   setActive(false);
    // }
  };
  return (
    <div className="d-flex align-items-center input-container mt-2 mb-2">
      <TextBox
        placeholder={t('REVISION_COMMENT')}
        onChange={(e) => setComment(e.target.value)}
        onBlur={onBlur}
        value={comment}
        autoFocus
        clearable={false}
      />
    </div>
  );
};
